require('./style.css');
var tmpl = require('./main.ejs');
var Events = require ('f.core.event');
var util = require('f.core.mobile.util');

var List = function (data) {
  this.data = data || [];
  this.init();
};

List.prototype.init = function () {
  this.initDom();
  this.initEvent();
};

List.prototype.initDom = function () {
  var div = document.createElement('div');
  div.innerHTML = tmpl({data: this.data});
  this.el = div.children[0];
};


List.prototype.initEvent = function () {

  util.tap(this.el, function (event, elm) {
    if ($(elm).hasClass('c-livevideo-list__item--selected')) {
      return false;
    }

    $(this.el).find('.c-livevideo-list__item--selected').removeClass('c-livevideo-list__item--selected');
    $(elm).addClass('c-livevideo-list__item--selected');
    this.trigger('switch', $(elm).data('url'), $(elm).data('index'));

    return false;
  }, {
    scope: this,
    delegate: '.c-livevideo-list__item'
  });

};

List.prototype.show = function () {
  $(this.el).stop().animate({
    right: '0px'
  });
};

List.prototype.hide = function () {
  $(this.el).stop().animate({
    right: '-600px'
  });
};

List.prototype.renderTo = function (parentNode) {
  parentNode.appendChild(this.el);
};

Events.mixTo(List);
module.exports = List;


// WEBPACK FOOTER //
// /Users/gebb/Desktop/live/modules/f.compenont.video.mobile/app/modules/list/index.js